let { Utils } = window.App;

$.fn.expandingGrid = function( options ){
    return this.each( function(){
        new Grid( this, options );
    } );
};

const SELECTOR = '.js-expanding-grid';

class Grid{
    constructor( el, options ){
        this.o = $.extend( {
            anim_duration: 500,
        }, options );
        this.el = el;
        this.$el = $( el );
        this.$items = this.$el.children();
        this.$pushers = this.$items.find( SELECTOR + '__pusher' );
        this.$triggers = this.$items.find( SELECTOR + '__trigger' );
        this.$expanders = this.$items.find( SELECTOR + '__expander' );
        this.$contents = this.$items.find( SELECTOR + '__content' );
        this.$close_buttons = this.$items.find( SELECTOR + '__close' );

        this.current = null;
        this.animating = false;

        this.bindEvents();

        let $item_to_expand = this.$items.filter( '[data-expand-at-load]' ).first();
        if( $item_to_expand.length ){
            this.openItem( $item_to_expand );
        }
    }

    bindEvents(){
        this.$triggers.on( 'click', $.proxy( this.onClickTrigger, this ) );
        this.$close_buttons.on( 'click', $.proxy( this.onClickClose, this ) );
        App.$window.on( 'resize', $.proxy( Utils.debounce( this.onWindowResize, 70 ), this ) );
    }

    onWindowResize(){
        if( this.current ){
            this.updateHeight( this.$items.eq( this.current ) );
        }
    }

    onClickTrigger( e ){
        if( this.animating ) return;
        e.preventDefault();

        let $target = $( e.currentTarget ),
            $item = $target.closest( this.$items ),
            item_index = this.$items.index( $item );

        if( this.current == item_index ){
            this.closeItem( $item );
            this.current = null;
        }else{
            this.openItem( $item );
        }
    }

    onClickClose( e ){
        if( this.animating ) return;
        e.preventDefault();

        let $target = $( e.currentTarget ),
            $item = $target.closest( this.$items );

        this.closeItem( $item );
        this.current = null;
    }

    async openItem( $item ){
        if( $item[0].hasAttribute( 'disabled' ) ){
            return false;
        }

        this.animating = true;
        $item.addClass( '__loading' );
        let response;

        if( $item.data( 'expanding-grid-ajax' ) ){
            try{
                response = await $.ajax( {
                    url: $item.data( 'expanding-grid-ajax' ),
                } );
            }catch( e ){}

            if( response ){
                $item.find( this.$contents.html( response ) );
            }
        }

        $item.imagesLoaded( _ => {
            $item.addClass( '__expanded' );
            $item.removeClass( '__loading' );

            let heights = this.getHeights( $item ),
                $expander = $item.find( this.$expanders ),
                $pusher = $item.find( this.$pushers ),
                item_index = this.$items.index( $item );

            if( this.current !== null ){
                let $current_item = this.$items.eq( this.current ),
                    current_top = $current_item.offset().top,
                    item_top = $item.offset().top;

                if( current_top === item_top ){
                    let $current_expander = $current_item.find( this.$expanders ),
                        $current_pusher = $current_item.find( this.$pushers ),
                        current_heights = this.getHeights( $current_item );

                    $pusher.height( current_heights.total_height );
                    $expander.height( current_heights.inner_height ).children().hide().fadeIn( this.o.anim_duration );

                    $current_pusher.add( $current_expander ).height( '' )
                    $current_item.removeClass( '__expanded' );
                }else{
                    this.closeItem( $current_item );

                    if( current_top < item_top ){
                        let $current_expander = $current_item.find( this.$expanders ),
                            current_expander_height = $current_expander.height(),
                            current_scroll_top = App.$window.scrollTop();

                        App.$html.add( App.$body ).animate( { 'scrollTop': current_scroll_top - current_expander_height }, this.o.anim_duration );
                    }
                }
            }

            $.when(
                $expander.animate( { height: heights.inner_height }, this.o.anim_duration ),
                $pusher.animate( { height: heights.total_height }, this.o.anim_duration ),
            ).then( _ => {
                this.updateHeight( $item );
                this.animating = false;
                this.current = item_index;
            } );
        } );
    }

    closeItem( $item ){
        let self = this,
            $expander = $item.find( this.$expanders ),
            $pusher = $item.find( this.$pushers ),
            item_height = $pusher.height();

        $item.removeClass( '__expanded' );

        this.animating = true;

        $pusher.height( '' );
        let item_height_to_go = $pusher.height();
        $pusher.height( item_height );


        $expander.animate( { height: 0 }, this.o.anim_duration ),
            $pusher.animate( { height: item_height_to_go }, this.o.anim_duration, function(){
                $pusher.height( '' );
                self.animating = false;
            } );
    }

    updateHeight( $item ){
        let heights = this.getHeights( $item ),
            $expander = $item.find( this.$expanders ),
            $pusher = $item.find( this.$pushers );

        $pusher.height( heights.total_height );
        $expander.height( heights.inner_height );
    }

    getHeights( $item ){
        let $expander = $item.find( this.$expanders ),
            $inner_expander = $expander.children(),
            $trigger = $item.find( this.$triggers ),
            inner_height = $inner_expander.outerHeight(),
            trigger_height = $trigger.outerHeight( true ),
            total_height = inner_height + trigger_height;

        return {
            inner_height: inner_height,
            total_height: total_height,
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/modules/expanding-grid/plugin.js